export default __webpack_public_path__ + "static/media/12.383a2332.jpg";